module.exports = __webpack_public_path__ + "static/media/news5-2.0fd3990c.jpg";